import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/indicadores/municipios/';

const getmunicipios = async (indicador) => {
    try {
        const response = await axios.get(`${baseUrl}${endpoint}${indicador}`);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error al obtener los indicadores:', error);
        throw error;
    }
};

export { getmunicipios };
